import { Pipe, PipeTransform } from '@angular/core';
import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { PaymentScenarionConditionTypeEnum } from '@zaoblako/shared/modules/task/enum/payment.scenarion.condition.type.enum';
import { PaymentScenarionConditionTypeEnumI18n } from '@zaoblako/shared/modules/task/i18n/payment-scenarion-condition-type.enum.i18n';

@Pipe({
  name: 'paymentTaskScenarioConditionTypeName',
  standalone: true
})
export class PaymentTaskScenarioConditionTypeNamePipe implements PipeTransform {
  public transform(type: PaymentScenarionConditionTypeEnum): string {
    return PaymentScenarionConditionTypeEnumI18n[I18nLocalesEnum.RU_RU][type] || '';
  }
}
